/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/

import iconSet from 'quasar/icon-set/material-icons'



import {QInput,QCheckbox,QSelect,QCard,QCardSection,QBtn,QBtnDropdown,QList,QItem,QItemSection,QSeparator,QIcon,QTooltip,Dialog,Notify,Meta} from 'quasar'



export default { config: {"screen":{"bodyClasses":true},"dark":"auto"},iconSet,components: {QInput,QCheckbox,QSelect,QCard,QCardSection,QBtn,QBtnDropdown,QList,QItem,QItemSection,QSeparator,QIcon,QTooltip},plugins: {Dialog,Notify,Meta} }

